import {
  Checkbox as CheckboxPrime,
  CheckboxProps as CheckboxPropsPrime,
} from "primereact/checkbox";
import styles from "./styles.module.css";

type CheckboxProps = { label: string } & CheckboxPropsPrime;

export function Checkbox({ label, ...props }: CheckboxProps) {
  return (
    <div className="flex align-items-center">
      <CheckboxPrime
        {...props}
        className={[props.className, styles.checkbox].join(" ")}
      />
      <label htmlFor={props.inputId} className="ml-2">
        {label}
      </label>
    </div>
  );
}
